<template>
  <div>
    <!-- REGISTRAR RECHAZO -->
    <b-modal v-model="modal.reject.active" size="lg" :key="'reject-' + modal.reject._id">
      <template #modal-header><div class="app-modal-header"><span class="app-modal-header__icon"><AppIcon name="block" /></span><h5 class="app-modal-header__title">Registrar rechazo</h5></div></template>

      <div v-if="modal.reject.cheque">
        <div class="cheques-rejections-summary">
          <div><span>Cheque</span><strong>{{ modal.reject.cheque.bank }} N.º {{ modal.reject.cheque.number }}</strong></div>
          <div><span>Importe</span><strong>{{ formatCurrency(modal.reject.cheque.amount) }}</strong></div>
          <div><span>Situación</span><strong>{{ rejectSituation.title }}</strong></div>
        </div>

        <div class="cheques-rejections-notice" :class="'cheques-rejections-notice--' + rejectSituation.tone"><AppIcon name="info" /> <span>{{ rejectSituation.text }}</span></div>

        <b-row>
          <b-col md="4">
            <b-form-group label="Fecha del rechazo">
              <b-form-input type="date" size="sm" v-model="crud.reject.date" />
            </b-form-group>
          </b-col>
          <b-col md="8">
            <b-form-group label="Motivo">
              <b-form-select size="sm" v-model="crud.reject.reason" :options="arr.reasons" />
            </b-form-group>
          </b-col>
          <b-col md="12" v-if="isDepositReject">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <b>Gastos del rechazo</b>
              <b-button variant="outline-dark" size="sm" @click="addExpense"><AppIcon name="add" class="mr-1" /> Agregar gasto</b-button>
            </div>
            <div class="cheques-rejections-text mb-2">Cargá un gasto por cada línea del extracto (comisión, IVA, etc.). Cada uno es un movimiento de la cuenta<template v-if="allowPurchaseLink">; los tipos que llevan comprobante de compra quedan pendientes hasta cargarlo desde Movimientos</template>.</div>
            <b-row v-for="(expense, index) in crud.reject.expenses" :key="index" class="mb-1">
              <b-col md="5"><b-form-select size="sm" v-model="expense.concept" :options="conceptOptions" /></b-col>
              <b-col md="3"><b-form-input size="sm" v-model="expense.description" placeholder="Detalle (opcional)" /></b-col>
              <b-col md="3"><b-input-group prepend="$" size="sm"><app-number-input v-model="expense.amount" /></b-input-group></b-col>
              <b-col md="1" class="text-right"><b-button variant="link" size="sm" class="text-danger" @click="crud.reject.expenses.splice(index, 1)"><AppIcon name="delete" /></b-button></b-col>
            </b-row>
            <hr class="mt-2 mb-3">
          </b-col>
          <b-col md="12">
            <b-form-group :label="crud.reject.reason == 'OTHER' ? 'Detalle del motivo (obligatorio)' : 'Observaciones'">
              <app-textarea v-model="crud.reject.observations" placeholder="Ingresar el detalle..." rows="2" max-rows="4"></app-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </div>

      <div slot="modal-footer">
        <b-button variant="outline-secondary" class="mr-1" @click="modal.reject.active=false"><AppIcon name="x" class="mr-1" /> Cancelar</b-button>
        <b-button variant="danger" @click="saveReject()"><AppIcon name="block" class="mr-1" /> Registrar rechazo</b-button>
      </div>
    </b-modal>

    <!-- VOLVER A CARTERA -->
    <b-modal v-model="modal.return.active" :key="'return-' + modal.return._id">
      <template #modal-header><div class="app-modal-header"><span class="app-modal-header__icon"><AppIcon name="undo" /></span><h5 class="app-modal-header__title">Volver a cartera</h5></div></template>

      <div v-if="modal.return.cheque">
        <p class="cheques-rejections-text">
          El cheque <strong>{{ modal.return.cheque.bank }} N.º {{ modal.return.cheque.number }}</strong> vuelve a cartera y se puede depositar de nuevo.
          Los movimientos del rechazo se conservan.
        </p>
        <b-form-group label="Motivo (obligatorio)">
          <app-textarea v-model="crud.return.observations" placeholder="Ej.: el cliente corrigió el endoso" rows="2" max-rows="4"></app-textarea>
        </b-form-group>
      </div>

      <div slot="modal-footer">
        <b-button variant="outline-secondary" class="mr-1" @click="modal.return.active=false"><AppIcon name="x" class="mr-1" /> Cancelar</b-button>
        <b-button variant="dark" @click="saveReturn()"><AppIcon name="undo" class="mr-1" /> Volver a cartera</b-button>
      </div>
    </b-modal>

    <!-- MARCAR COMO RESUELTO -->
    <b-modal v-model="modal.resolve.active" :key="'resolve-' + modal.resolve._id">
      <template #modal-header><div class="app-modal-header"><span class="app-modal-header__icon"><AppIcon name="task_alt" /></span><h5 class="app-modal-header__title">Marcar rechazo como resuelto</h5></div></template>

      <div v-if="modal.resolve.cheque">
        <p class="cheques-rejections-text">
          El rechazo del cheque <strong>{{ modal.resolve.cheque.bank }} N.º {{ modal.resolve.cheque.number }}</strong> se arregló sin nota de débito.
          Sale de los rechazados pendientes y el cheque sigue fuera de uso (no vuelve a cartera).
        </p>
        <b-form-group label="¿Cómo se resolvió?">
          <b-form-select size="sm" v-model="crud.resolve.reason" :options="arr.resolutionReasons" />
        </b-form-group>
        <b-form-group :label="crud.resolve.reason == 'OTHER' ? 'Detalle (obligatorio)' : 'Observaciones'">
          <app-textarea v-model="crud.resolve.observations" placeholder="Ej.: el cliente lo reemplazó con una transferencia" rows="2" max-rows="4"></app-textarea>
        </b-form-group>
      </div>

      <div slot="modal-footer">
        <b-button variant="outline-secondary" class="mr-1" @click="modal.resolve.active=false"><AppIcon name="x" class="mr-1" /> Cancelar</b-button>
        <b-button variant="dark" @click="saveResolve()"><AppIcon name="task_alt" class="mr-1" /> Marcar como resuelto</b-button>
      </div>
    </b-modal>

    <!-- VINCULAR NOTA DE DÉBITO -->
    <b-modal v-model="modal.link.active" :key="'link-' + modal.link._id">
      <template #modal-header><div class="app-modal-header"><span class="app-modal-header__icon"><AppIcon name="link" /></span><h5 class="app-modal-header__title">Vincular nota de débito</h5></div></template>

      <p class="cheques-rejections-text">Notas de débito del cliente de origen. Elegí la que se emitió por este cheque rechazado.</p>
      <div v-if="modal.link.loading" class="cheques-rejections-text">Cargando…</div>
      <b-form-radio-group v-else-if="modal.link.items.length" v-model="crud.link.sales_id" stacked class="cheques-rejections-options">
        <b-form-radio v-for="item in modal.link.items" :key="item.id" :value="item.id">
          <strong>{{ item.reference }}</strong>
          <span class="cheques-rejections-text"> · {{ moment(item.date).format('DD/MM/YYYY') }} · {{ formatCurrency(item.amount_total) }}</span>
        </b-form-radio>
      </b-form-radio-group>
      <div v-else class="cheques-rejections-text">El cliente no tiene notas de débito (o el cheque no vino de un recibo).</div>

      <div slot="modal-footer">
        <b-button variant="outline-secondary" class="mr-1" @click="modal.link.active=false"><AppIcon name="x" class="mr-1" /> Cancelar</b-button>
        <b-button variant="dark" :disabled="!crud.link.sales_id" @click="saveLink()"><AppIcon name="link" class="mr-1" /> Vincular</b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import serviceAPI from '../services'
  import Error from '@/handler/error'
  import moment from 'moment'

  export default {
    data: () => {
      return {
        crud: {
          reject: {
            date: '',
            reason: 'NO_FUNDS',
            observations: '',
            expenses: [],
          },
          return: {
            observations: '',
          },
          link: {
            sales_id: null,
          },
          resolve: {
            reason: 'REPLACED',
            observations: '',
          },
        },
        modal: {
          reject: { active: false, cheque: null },
          return: { active: false, cheque: null },
          link: { active: false, cheque: null, items: [], loading: false },
          resolve: { active: false, cheque: null },
        },
        arr: {
          concepts: [],
          reasons: [
            { value: 'NO_FUNDS', text: 'Sin fondos suficientes' },
            { value: 'FORMAL_DEFECTS', text: 'Defectos formales' },
            { value: 'STOP_PAYMENT', text: 'Orden de no pagar' },
            { value: 'CLOSED_ACCOUNT', text: 'Cuenta cerrada o embargada' },
            { value: 'SIGNATURE', text: 'Firma no registrada o irregular' },
            { value: 'OTHER', text: 'Otro motivo' },
          ],
          resolutionReasons: [
            { value: 'REPLACED', text: 'Reemplazado por otro pago' },
            { value: 'RETURNED_TO_CUSTOMER', text: 'Devuelto al cliente' },
            { value: 'COLLECTED', text: 'Cobrado por fuera' },
            { value: 'OTHER', text: 'Otro' },
          ],
        },
      }
    },
    computed: {
      allowPurchaseLink() {
        var cheque = this.modal.reject.cheque
        return !!(cheque && cheque.destino && cheque.destino.allow_purchase_link)
      },
      conceptOptions() {
        return this.arr.concepts.map(type => ({
          value: type.value,
          text: type.text + (type.purchase && this.allowPurchaseLink ? ' (lleva comprobante)' : ''),
        }))
      },
      isDepositReject() {
        const cheque = this.modal.reject.cheque
        return !!cheque && ['DEPOSITED', 'CREDITED'].includes(cheque.status)
      },
      // qué va a pasar según el estado del cheque
      rejectSituation() {
        const cheque = this.modal.reject.cheque
        if(!cheque) return { title: '', text: '', tone: 'info' }
        const cash = cheque.destino && cheque.destino.cash ? cheque.destino.cash : 'la cuenta'
        if(cheque.status == 'DEPOSITED') {
          return { title: 'Depositado, pendiente', tone: 'info',
                   text: 'El cheque sale del depósito sin ingresar a ' + cash + '. Si el banco cobró gastos, se registran como egreso.' }
        }
        if(cheque.status == 'CREDITED') {
          return { title: 'Acreditado', tone: 'warning',
                   text: 'Se registra un egreso en ' + cash + ' por el importe del cheque (el banco lo debita) y otro por los gastos, si los hubo.' }
        }
        return { title: 'Entregado a proveedor', tone: 'info',
                 text: 'El proveedor lo devolvió: el cheque queda rechazado en la mano. La orden de pago no se modifica; la nota de débito del proveedor y el nuevo pago se cargan aparte.' }
      },
    },
    mounted() {
      // tipos de movimiento bancario que son egresos (FinancesCashDetail::BANK_TYPES)
      serviceAPI.obtenerTiposMovimientoBancario().then((response) => {
        this.arr.concepts = response.data.filter(type => type.balance != '+')
      })
    },
    methods: {
      addExpense() {
        this.crud.reject.expenses.push({ concept: 'COMISION', description: '', amount: 0 })
      },
      formatCurrency(value) {
        return Intl.NumberFormat('es-AR',{style:'currency',currency:'ARS'}).format(value)
      },

      // REGISTRAR RECHAZO
      reject(cheque) {
        this.crud.reject.date = moment().format('YYYY-MM-DD')
        this.crud.reject.reason = 'NO_FUNDS'
        this.crud.reject.observations = ''
        this.crud.reject.expenses = []

        this.modal.reject.cheque = cheque
        this.modal.reject._id = Math.random().toString(36).slice(2, 8)
        this.modal.reject.active = true
      },
      saveReject() {
        let loader = this.$loading.show()
        serviceAPI.rechazarCheque(this.modal.reject.cheque.id, this.crud.reject)
        .then(() => {
          loader.hide()
          this.modal.reject.active = false
          this.$emit('changed')
          this.$awn.success("Rechazo registrado")
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        })
      },

      // VOLVER A CARTERA
      returnToPortfolio(cheque) {
        this.crud.return.observations = ''
        this.modal.return.cheque = cheque
        this.modal.return._id = Math.random().toString(36).slice(2, 8)
        this.modal.return.active = true
      },
      saveReturn() {
        let loader = this.$loading.show()
        serviceAPI.volverACarteraRechazo(this.modal.return.cheque.rejection.id, this.crud.return)
        .then(() => {
          loader.hide()
          this.modal.return.active = false
          this.$emit('changed')
          this.$awn.success("El cheque volvió a cartera")
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        })
      },

      // ANULAR RECHAZO (error de carga)
      cancel(cheque) {
        this.$bvModal.msgBoxConfirm('Se eliminan los movimientos del rechazo y el cheque vuelve al estado anterior (depositado, acreditado o entregado). Usalo solo si el rechazo se cargó por error.', {
          title: 'Anular rechazo',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Anular rechazo',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerClass: 'app-confirm-header app-confirm-header--danger',
          centered: true
        })
        .then(value => {
          if(!value) return
          let loader = this.$loading.show()
          serviceAPI.anularRechazo(cheque.rejection.id)
          .then(() => {
            loader.hide()
            this.$emit('changed')
            this.$awn.success("Rechazo anulado")
          })
          .catch(error => {
            loader.hide()
            this.$awn.alert(Error.showError(error))
          })
        })
      },

      // MARCAR COMO RESUELTO / REABRIR
      resolve(cheque) {
        this.crud.resolve.reason = 'REPLACED'
        this.crud.resolve.observations = ''
        this.modal.resolve.cheque = cheque
        this.modal.resolve._id = Math.random().toString(36).slice(2, 8)
        this.modal.resolve.active = true
      },
      saveResolve() {
        let loader = this.$loading.show()
        serviceAPI.resolverRechazo(this.modal.resolve.cheque.rejection.id, this.crud.resolve)
        .then(() => {
          loader.hide()
          this.modal.resolve.active = false
          this.$emit('changed')
          this.$awn.success("Rechazo marcado como resuelto")
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        })
      },
      reopen(cheque) {
        serviceAPI.reabrirRechazo(cheque.rejection.id)
        .then(() => {
          this.$emit('changed')
          this.$awn.success("Rechazo reabierto: vuelve a los pendientes")
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        })
      },

      // NOTA DE DÉBITO
      generateDebitNote(cheque) {
        this.$router.push({ name: 'SalesStaffSalesGenerateByChequeRejection', params: { chequeRejectionID: cheque.rejection.id } }).catch(() => {})
      },
      linkDebitNote(cheque) {
        this.crud.link.sales_id = null
        this.modal.link.cheque = cheque
        this.modal.link.items = []
        this.modal.link.loading = true
        this.modal.link._id = Math.random().toString(36).slice(2, 8)
        this.modal.link.active = true

        serviceAPI.notasDebitoRechazo(cheque.rejection.id)
        .then((response) => {
          this.modal.link.items = response.data
          this.modal.link.loading = false
        })
        .catch(error => {
          this.modal.link.loading = false
          this.$awn.alert(Error.showError(error))
        })
      },
      saveLink() {
        serviceAPI.vincularNotaDebitoRechazo(this.modal.link.cheque.rejection.id, this.crud.link.sales_id)
        .then(() => {
          this.modal.link.active = false
          this.$emit('changed')
          this.$awn.success("Nota de débito vinculada")
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        })
      },
      // desvincular no anula la ND: el cliente la sigue debiendo hasta que se anule con una NC en Ventas
      unlinkDebitNote(cheque) {
        var reference = cheque.rejection.sales_reference || 'vinculada'
        this.$bvModal.msgBoxConfirm('La nota de débito ' + reference + ' sigue vigente en Ventas: desvincularla no la anula. Si corresponde anularla, hacelo con una nota de crédito. El rechazo vuelve a quedar pendiente.', {
          title: 'Desvincular nota de débito',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'primary',
          okTitle: 'Desvincular',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerClass: 'app-confirm-header',
          centered: true
        })
        .then(value => {
          if(!value) return
          let loader = this.$loading.show()
          serviceAPI.vincularNotaDebitoRechazo(cheque.rejection.id, null)
          .then(() => {
            loader.hide()
            this.$emit('changed')
            this.$awn.success("Nota de débito desvinculada")
          })
          .catch(error => {
            loader.hide()
            this.$awn.alert(Error.showError(error))
          })
        })
      },
    }
  }
</script>
<style scoped>
  .cheques-rejections-summary { background: var(--app-color-surface-subtle); border: 1px solid var(--app-color-border); border-radius: 7px; display: flex; flex-wrap: wrap; gap: 16px; margin-bottom: 10px; padding: 10px 12px; }
  .cheques-rejections-summary span { color: var(--app-color-text-secondary); display: block; font-size: var(--app-text-xs); }
  .cheques-rejections-notice { align-items: flex-start; border: 1px solid; border-radius: 7px; display: flex; font-size: var(--app-text-sm); gap: 6px; margin-bottom: 12px; padding: 8px 10px; }
  .cheques-rejections-notice--info { background: var(--app-color-info-soft); border-color: var(--app-color-info-border); color: var(--app-color-primary-active); }
  .cheques-rejections-notice--warning { background: var(--app-color-warning-soft); border-color: var(--app-color-warning-border); color: var(--app-color-warning-hover); }
  .cheques-rejections-text { color: var(--app-color-text-secondary); font-size: var(--app-text-sm); }
  .cheques-rejections-options >>> .custom-control { margin-bottom: 8px; }
</style>
